import type { SVGAttributes } from 'react';

export function DescriptionIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M26.6654 11.0003V24.0003C26.6654 28.0003 24.2787 29.3337 21.332 29.3337H10.6654C7.7187 29.3337 5.33203 28.0003 5.33203 24.0003V11.0003C5.33203 6.66699 7.7187 5.66699 10.6654 5.66699C10.6654 6.49366 10.9987 7.24032 11.5453 7.78699C12.092 8.33365 12.8387 8.66699 13.6654 8.66699H18.332C19.9854 8.66699 21.332 7.32033 21.332 5.66699C24.2787 5.66699 26.6654 6.66699 26.6654 11.0003Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M21.3346 5.66699C21.3346 7.32033 19.988 8.66699 18.3346 8.66699H13.668C12.8413 8.66699 12.0946 8.33365 11.5479 7.78699C11.0013 7.24032 10.668 6.49366 10.668 5.66699C10.668 4.01366 12.0146 2.66699 13.668 2.66699H18.3346C19.1613 2.66699 19.908 3.00033 20.4547 3.547C21.0013 4.09366 21.3346 4.84033 21.3346 5.66699Z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M10.668 17.333H16.0013"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				opacity="0.4"
				d="M10.668 22.667H21.3346"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
